<script lang="ts">
  import type { SwiperOptions } from 'swiper/types';
  import { isMobile } from '../../../common/util';
  import CmsBrandLinkSlideTemplate from '../components/CMSBrandLinkSlideTemplate.svelte';
  import ExtraSwiper from '../components/ExtraSwiper.svelte';
  import ImageTag from './ImageTag.svelte';

  export let metaData;
  export let cmsLinks;
  export function onLoad() {}

  const isResponsive = isMobile();
  const spaceBetween = isResponsive ? 12 : 16;
  const swiperOptions = getSwiperOptions(spaceBetween);

  function getSwiperOptions(spaceBetween): SwiperOptions {
    return {
      slidesPerView: 'auto',
      spaceBetween,
    };
  }
  console.log(cmsLinks, 'cmsLinks');
</script>

<section class="brand-link-container">
  <section class="logo-and-info px40">
    <section class="logo">
      <ImageTag imageUrls={[metaData?.brandLogoUrl]} maxHeight={28} />
    </section>
    <section class="info">
      <h3>{metaData?.title}</h3>
      <a href={metaData?.shopAllProductsLink?.url}>{metaData?.shopAllProductsLink?.linkName}</a>
    </section>
  </section>
  <section class="brand-items">
    <ExtraSwiper slidesData={cmsLinks} slideTemplate={CmsBrandLinkSlideTemplate} {swiperOptions} />
  </section>
</section>

<style lang="scss">
  @import '../styles/colors.new.scss';

  .brand-link-container {
    background-color: $secondary-gray-02;
    border-radius: 12px;
    padding-block: 24px;

    @include desktop-min-width {
      border-radius: 20px;
      padding-block: 40px;
    }
    .px40 {
      padding-inline: 24px;

      @include desktop-min-width {
        padding-inline: 40px;
      }
    }
  }
  .logo-and-info {
    display: flex;
    gap: 12px;
    align-items: center;

    @include desktop-min-width {
      display: block;
    }

    .logo {
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;

      @include desktop-min-width {
        display: block;
        width: unset;
        height: unset;
      }
    }

    h3 {
      margin-block: 0;
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
      color: $neutral-dark-01;

      @include desktop-min-width {
        margin-block: 40px 0;
        font-size: 28px;
        line-height: 32px;
      }
    }
    a {
      display: inline-block;
      margin-block: 4px 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      color: $icon-only-icon-blue;

      @include desktop-min-width {
        margin-block: 8px 0;
        font-size: 16px;
        line-height: 18px;
      }
    }
  }
  .brand-items {
    margin-top: 40px;
    max-width: -webkit-fill-available;

    :global {
      .brand-item-tile {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-block: 8px;
        width: 130px;
        aspect-ratio: 1;
        background-color: $primary-white;
        border-radius: 8px;

        @include desktop-min-width {
          width: 178px;
          padding-block: 16px 18px;
        }

        h4 {
          margin-block: 8px;
          font-size: 14px;
          font-weight: 700;
          line-height: 16px;
          color: $neutral-dark-01;

          @include desktop-min-width {
            margin-block: 20px 8px;
            font-size: 18px;
            line-height: 20px;
          }
        }
        p {
          margin: 0;
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          color: $neutral-dark-03;

          @include desktop-min-width {
            font-size: 14px;
            font-weight: 700;
            line-height: 16px;
          }
        }
      }

      .swiper-slide {
        width: auto;
        &:first-child {
          margin-left: 24px;

          @include desktop-min-width {
            margin-left: 40px;
          }
        }
        &:last-child {
          margin-right: 24px;

          @include desktop-min-width {
            margin-right: 40px;
          }
        }
      }
    }
  }
</style>
